
import './App.css';
import './Style.css';
import './home.css';
import './main.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Home from './Component/Home';
import Launchpad from './Component/Launchpad';
import LockedStake from './Component/LockedStaking';
import News from './Component/News';
import Newsdetails from './Component/Newsdetails';
import Articles from './Component/Articles';
import toast, { Toaster } from 'react-hot-toast';
import Map from './Component/Map';

import Demo from "./Component/demo";
import Home from './Component/Home';
import Explained from './Component/Explained';
import About from './Component/About';
import Philosophy from './Component/Philosophy';
import Charter from './Component/Charter';
import Whitepaper from './Component/Whitepaper';
// import Landing from './Component/Landing';
import { lazy, Suspense } from 'react';
import AIcompute from './Component/AIcompute.js';
import Depin from './Pages/Depin.js';
import Storage from './Pages/Storage.js';
import Loader from './Component/Loader.js';


// lazy load components

const Landing = lazy(() => import('./Pages/Landing.js'))

function App() {
  return (
    <div className="App">
      <BrowserRouter >
        <div><Toaster /></div>
        <Suspense fallback={<Loader />}>
          <Routes>
            {/* <Route path="/" element={<Land />} /> */}
            {/* <Route path="/" element={<Home1 />} /> */}
            {/* <Route path="/" element={<Demo />} /> */}
            {/* <Route path="/" element={<Home />} /> */}
            <Route path="/" element={<Landing />} />

            <Route path="/launchpad" element={<Launchpad />} />
            <Route path="/staking" element={<LockedStake />} />
            <Route path="/news" element={<News />} />
            <Route path="/newsdetails" element={<Newsdetails />} />
            <Route path="/newsdetails/:id" element={<Newsdetails />} />
            <Route path="/latestarticles/:id" element={<Articles />} />
            <Route path="/map" element={<Map />} />
            {/* <Route path="/explained" element={<Explained />} />
          <Route path="/about" element={<About />} /> */}
            <Route path="/about" element={<Explained />} />
            <Route path="/paradigm" element={<About />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/charter" element={<Charter />} />
            {/* <Route path="/whitepaper" element={<Whitepaper />} /> */}

            <Route path="/demo" element={<Demo />} />
            <Route path="/ai-compute" element={<AIcompute />} />
            <Route path="/storage" element={<Storage />} />
            <Route path="/depin" element={<Depin />} />
            {/* <Route path="/loader" element={<Loader />} /> */}

          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
